import trelloStore from './trellostore';
import StoreKeys from './storekeys';
import config from './config';
//var t = TrelloPowerUp.iframe({ helpfulStacks: true });

export interface IUserData {
    trelloApiToken: string,
    trelloEmail: string,
    trelloUserName: string,
    trelloFullName: string,
    trelloInitals: string,
    terlloUserId: string,
    stobApiToken: string;
}

interface IUser {
    currentUserHasWritePermission(options:any) : boolean;
    getUserData(): Promise<IUserData>;
    getHasToken(): Promise<boolean>;
    set(userData:IUserData): Promise<any> ;
    removeUserData();
    setPersonalAccessToken(pat: string): Promise<void>;
    removePersonalAccessToken(): Promise<void>;
}

class User implements IUser {

    private t: any;

    constructor(t?: any) {
        this.t = t;
    }

    public using(t: any) : IUser {
        return new User(t);
    }

    public currentUserHasWritePermission(options:any) {
        if (options.context.permissions.board === 'write') {
            return true;
        }
        return false;
    }

    public getUserData(): Promise<IUserData> {
        var self = this;
        return new Promise(resolve => {
            trelloStore(self.t).getMemberPrivate(StoreKeys.Member.Token)
            .then((json) => {
                var token = undefined;
                if (json) {
                    var token = JSON.parse(json);
                }
                resolve(token);
            });
        });
    }

//     public retrieveUserData(): Promise<IUserData> {
//         var self = this;
//         var userData = null;
//         return new Promise(resolve => {
//             trelloStore(self.t).getMemberPrivate(StoreKeys.Member.Token)
//             .then((json) => {
// console.info(json, "getUserData json");
//                 if (json) {
//                     userData = JSON.parse(json);
//                 }
//                 else {
//                     userData = this.doAuth();
//                 }
//                 resolve(userData);
//             });
//         });
//     }

    // public doAuth() {
    //     var self = this;
    //     var userData = null;
    //     Trello.setKey(config(t).getAppKey());
    //     Trello.authorize({
    //         type: 'popup',
    //         name: 'Agile Power PowerUp',
    //         persist: false,
    //         scope: {
    //           read: 'true',
    //           write: 'true',
    //           account: 'true' },
    //         expiration: 'never',
    //         success: (res) => {
    //             var token = Trello.token();
    //             Trello.get('members/me', null,
    //                 async (res) => {
    //                     var userData: IUserData = {
    //                         trelloApiToken : token,
    //                         terlloUserId : res.id,
    //                         trelloEmail : res.email,
    //                         trelloFullName: res.fullName,
    //                         trelloInitals: res.initials,
    //                         trelloUserName: res.username,
    //                         stobApiToken: ''
    //                     };
    //                     userData = await user(self.t).set(userData);
    //                 },
    //                 (err) => {
    //                 });
    //         },
    //         error: (res) => {
    //         },
    //     });
    //     return userData;
    // }

    public getHasToken(): Promise<boolean> {
        var self = this;
        return new Promise(resolve => {
            self.getUserData().then(ud => {
                if (ud && ud.stobApiToken && ud.stobApiToken != "") {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            })
        })
    }


    public set(userData:IUserData): Promise<any> {
        var self = this;
        return new Promise(resolve => {
            trelloStore(self.t)
            .setMemberPrivate(StoreKeys.Member.Token,JSON.stringify(userData))
            .then(() => {
                resolve(true);
            })
        });
    }

    public removeUserData(): Promise<any> {
        var self = this;
        return new Promise(resolve => {
            trelloStore(self.t)
            .removeMemberPrivate(StoreKeys.Member.Token)
            .then(() => {
                resolve(true);
            })
        });
    }

    public setPersonalAccessToken = async (pat: string) => {
        var userData = await this.getUserData();
        if(!userData) {
            userData = <any>{};
        }
        userData.stobApiToken = pat || "";
        await this.set(userData);
    }

    public removePersonalAccessToken = () => {
        return this.setPersonalAccessToken("");
    }
}


export var user = function(t: any): IUser { return new User().using(t); }
export default user;
